<template>
  <!-- 帮帮-帮帮 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题 帮帮 -->
      <p class="title-Individual-center">
        帮帮
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">{{
          Toggle == "1" ? "找帮帮" : "来帮帮"
        }}</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- 找帮帮/来帮帮  切换按钮 -->
        <div class="help-Toggle">
          <p
            v-for="(item, index) in ToggleArr"
            :key="index"
            :class="Toggle == item.id ? 'select' : ''"
            @click="handelToggle(item)"
          >
            {{ item.name }}
          </p>
        </div>
        <!-- 筛选  地区/类型/类别 -->
        <div class="screenContent">
          <div class="Content">
            <p class="ContentTitle">地区：</p>
            <div class="ContentOptions">
              <p class="orientation"></p>
              <p class="city firm-clickable" @click="handelAddress">河南-南阳</p>
            </div>
          </div>
          <div class="Content">
            <p class="ContentTitle">类型：</p>
            <div class="ContentOptions">
              <p
                v-for="(item, index) in typeArr"
                :key="index"
                class="typeScreen"
                :class="item.id == typeSelect ? 'typeSelect' : ''"
                @click="typeSelect = item.id"
              >
                {{ item.name }}
              </p>
            </div>
          </div>
          <div class="Content">
            <p class="ContentTitle">类别：</p>
            <div class="ContentOptions">
              <p
                v-for="(item, index) in categoryArr"
                :key="index"
                class="typeScreen"
                :class="item.id == categorySelect ? 'typeSelect' : ''"
                @click="categorySelect = item.id"
              >
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
        <!-- 找帮帮/来帮帮  切换按钮 -->
        <div class="help-Toggle">
          <p
            v-for="(item, index) in personageAndFirm"
            :key="index"
            :class="Select == item.id ? 'selectTog' : 'notSelectTog'"
            @click="handelSelect(item)"
          >
            {{ item.name }}
          </p>
        </div>
        <!-- 内容展示 -->
        <div class="help-Content-Show">
          <ServiceItem
            :listArr="listArr"
            :distinguish="2"
            v-if="Toggle == '1'"
            @handelAskForHelp="handelAskForHelp"
          ></ServiceItem>
          <Requirement
            :listArr="listArr1"
            :distinguish="2"
            v-else
            @handelComeAndHelp="handelComeAndHelp"
          ></Requirement>
        </div>
        <!-- 分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paging from "../../../../components/paging.vue"; // 分页
import ServiceItem from "../HelpShop/moduleThree/components/ServiceItem.vue"; // 找帮帮 内容模块
import Requirement from "../HelpShop/moduleThree/components/Requirement.vue"; // 来帮帮 内容模块
export default {
  data() {
    return {
      ToggleArr: [
        {
          name: "找帮帮",
          id: "1",
        },
        {
          name: "来帮帮",
          id: "2",
        },
      ],
      Toggle: "1", // 切换选中
      personageAndFirm: [
        { name: "个人", id: "1" },
        { name: "企业", id: "2" },
      ], //个人/企业切换
      Select: "2", // 个人企业切换
      typeArr: [
        {
          name: "全部",
          id: "0",
        },
        {
          name: "工商服务",
          id: "1",
        },
        {
          name: "财税服务",
          id: "2",
        },
        {
          name: "知识产权服务",
          id: "3",
        },
        {
          name: "营销策划",
          id: "4",
        },
        {
          name: "运营",
          id: "5",
        },

        {
          name: "AI",
          id: "6",
        },
        {
          name: "VR/AR",
          id: "7",
        },
        {
          name: "IT技术服务",
          id: "8",
        },
        {
          name: "网络建设服务",
          id: "9",
        },
        {
          name: "移动端开发",
          id: "10",
        },
        {
          name: "软件开发",
          id: "11",
        },
        {
          name: "设计服务",
          id: "12",
        },
        {
          name: "动画/漫画",
          id: "13",
        },
        {
          name: "影音视频",
          id: "14",
        },
        {
          name: "工商设计",
          id: "15",
        },
        {
          name: "UI设计",
          id: "16",
        },
        {
          name: "电商设计",
          id: "17",
        },
        {
          name: "品牌设计",
          id: "18",
        },
        {
          name: "产品",
          id: "19",
        },
      ], // 筛选类型
      typeSelect: "0", // 筛选类型选中
      categoryArr: [
        {
          name: "全部",
          id: "0",
        },
        {
          name: "工商变更",
          id: "1",
        },
        {
          name: "工商异常",
          id: "2",
        },
        {
          name: "银行开户",
          id: "3",
        },
        {
          name: "印章",
          id: "4",
        },
        {
          name: "资质/办理",
          id: "5",
        },
        {
          name: "公司注册",
          id: "6",
        },
        {
          name: "公司注销",
          id: "7",
        },
        {
          name: "公司转让",
          id: "8",
        },
        {
          name: "其他工商服务",
          id: "9",
        },
      ], //类别
      categorySelect: "0", // 类别筛选选中
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
      listArr: [
        {
          status: "0", // 状态 0已上架  1审核  2审核失败 3已下架
          choose: false,
        },
        { status: "0", choose: false },
        { status: "0", choose: false },
        { status: "1", choose: false },
        { status: "2", choose: false },
        { status: "3", choose: false },
        { status: "2", choose: false },
        { status: "0", choose: false },
      ], //找帮帮数据
      listArr1: [
        {
          status: "0", // 状态 0招标  1进行中  2审核  3审核失败 4已下架  5已完成
          choose: false,
        },
        { status: "1", choose: false },
        { status: "2", choose: false },
        { status: "3", choose: false },
        { status: "4", choose: false },
        { status: "5", choose: false },
        { status: "1", choose: false },
        { status: "0", choose: false },
      ], //来帮帮数据
    };
  },
  watch: {
    // 监听页面路径
    $route() {
      console.log(this.$route);
    },
  },
  components: {
    // 分页
    paging,
    // 找帮帮模块
    ServiceItem,
    // 来帮帮模块
    Requirement,
  },
  created() {
    if (this.$route.query.key != "" && this.$route.query.key != undefined) {
      this.Toggle = this.$route.query.key;
      this.$router.push({ query: {} });
    }
  },
  destroyed() {
    // sessionStorage.removeItem("select");
  },
  methods: {
    // 点击地区 切换地址
    handelAddress(){},
    // 点击对应的找帮帮模块
    handelAskForHelp(val) {
      this.$router.push({
        path: "/HelpShop/Help/HelpAskForHelp",
      });
    },
    // 点击对应的来帮帮
    handelComeAndHelp(val) {
      // // 打开新窗口 跳转新页面  跳转搜索详情
      // let routeData = this.$router.resolve({
      //   path: "/HelpShop/Help/ComeAndHelp",
      // });
      // window.open(routeData.href, "_blank");

      // 不打开新窗口跳转
      this.$router.push({
        path: "/HelpShop/Help/ComeAndHelp",
      });
    },
    // 个人/企业
    handelSelect(item) {
      this.Select = item.id;
    },
    // 切换找帮帮 来帮帮
    handelToggle(item) {
      this.Toggle = item.id;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
    },
    // handelClick(item) {
    //   sessionStorage.setItem("select", item.id); //会话存储
    //   this.select = item.id;
    // },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-family: PingFangSC-Medium;
  color: #333333;
  font-weight: 400;
  // 找帮帮  来帮帮切换     个人/企业切换
  .help-Toggle {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    p {
      width: 110px;
      height: 35px;
      background: #eeeeee;
      border-radius: 5px;
      font-size: 12px;
      color: #333333;
      text-align: center;
      margin-right: 10px;
      cursor: pointer;
    }
    .select {
      background: rgba(97, 144, 232, 0.2);
      color: #409eff ;
      cursor: pointer;
    }
    .notSelectTog {
      background: #ffffff;
      box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
      border-radius: 10px 10px 0px 0px;
    }
    .selectTog {
      background: #ffffff;
      border: 1px solid #409eff ;
      box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
      border-radius: 10px 10px 0px 0px;
      color: #409eff ;
    }
  }
  // 筛选
  .screenContent {
    width: 100%;
    min-height: 150px;
    margin: 30px 0px 0px 0px;
    .Content {
      //   width: 100%;
      width: 1140px;
      min-height: 17px;
      line-height: 17px;
      display: flex;
      flex-wrap: wrap;
      .ContentTitle {
        width: 60px;
        font-size: 14px;
        color: #333300;
      }
      .ContentOptions {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        .orientation {
          width: 15px;
          height: 16px;
          margin-right: 5px;
          background-image: url("../../../../assets/imgs/dingwei@3x.svg");
          background-size: 100% 100%;
        }
        .city {
          color: #409eff ;
          cursor: pointer;
          margin-bottom: 30px;
        }
        .typeScreen {
          margin-right: 20px;
          margin-bottom: 30px;
          cursor: pointer;
        }
        .typeSelect {
          color: #409eff ;
        }
      }
    }
  }
  //内容
  .help-Content-Show {
    width: 1140px;
    min-height: 500px;
    margin-top: 30px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  //   margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
